"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToFormUrlencoded = void 0;
function isObject(o) {
    return (!(o instanceof Array) && (o instanceof Object));
}
function formatToFormUrlencoded(obj) {
    if (!isObject(obj)) {
        return '';
    }
    const ret = [];
    for (const key in obj) {
        if (obj[key] !== null && obj[key] !== undefined) {
            ret.push(`${key}=${encodeURIComponent(obj[key])}`);
        }
    }
    return ret.join('&');
}
exports.formatToFormUrlencoded = formatToFormUrlencoded;
//# sourceMappingURL=FormatToFormUrlencoded.js.map